var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.isDesktop)?_c('div',{staticClass:"tituloEscritorio"},[_c('img',{staticStyle:{"width":"-webkit-fill-available"},attrs:{"src":_vm.barraFondo,"alt":"Imagen Escritorio"}})]):_c('div',{staticClass:"tituloMobile"},[_c('img',{attrs:{"src":_vm.barraFondoMobile,"alt":"Imagen Móvil"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }